import React, { Component } from "react";
import slugify from "slugify";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as BenefitsTypesActions } from "store/ducks/benefitsTypes";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/Types/components";

class Create extends Component {
  state = {
    data: {
      id: "",
      title: "",
      description: "",
      slug: "",
      plan_ids: "",
      active: false,
      automatically_activated: false,
      segments: [],
      onboarding_only: false,
      onboarding_end_at: null,
      onboarding_start_at: null,
      extra_data: {
        invalidable: false,
        gift: false,
        transferable_expires_in: "",
        legal_term: "",
      },
      usable: true,
      transferable: false,
    },
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Lista de Tipos de Benefícios", to: "/benefits/types/list" },
      { name: "Adicionar Novo", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },
      description: {
        required: true,
      },
      plan_ids: {
        required: true,
      },
      onboarding_end_at: {
        required: data.onboarding_only,
      },
      onboarding_start_at: {
        required: data.onboarding_only,
      },
    };

    const validate = Validate(data, rules);

    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { createBenefitsTypesRequest } = this.props;

    createBenefitsTypesRequest({
      title: data.title,
      description: data.description,
      slug: slugify(data.title, {
        replacement: "-",
        remove: null,
        lower: true,
      }),
      active: data.active,
      automatically_activated: data.automatically_activated,
      usable: data.usable,
      transferable: data.transferable,
      extra_data: {
        onboarding_only: data.onboarding_only,
        onboarding_end_at: data.onboarding_end_at,
        onboarding_start_at: data.onboarding_start_at,
        invalidable: data.extra_data.invalidable,
        experience_plan_ids: data.plan_ids,
        segments: data.segments,
        gift: data.extra_data.gift,
        transferable_expires_in: parseInt(
          data.extra_data.transferable_expires_in
        ),
        legal_term: data.extra_data.legal_term,
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  create: state.benefitsTypes.create,
});

const mapActions = (dispatch) =>
  bindActionCreators(BenefitsTypesActions, dispatch);

export default connect(mapState, mapActions)(Create);
